import t from "./ghl-ui.es1517.js";
import i from "./ghl-ui.es1466.js";
function g(r, a) {
  i(2, arguments);
  var e = t(r), f = t(a);
  return e.getTime() === f.getTime();
}
export {
  g as default
};
